import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'usedBy',
      type: 'select',
      filterable: true,
      label: '使用人',
      clearable: true
    },
    {
      field: 'extProfile',
      type: 'input',
      label: '号码注册人',
      placeholder: '请输入号码注册人'
    }
  ],
  colLayout: 24
}
